import React from "react";
import { AuthService } from "../../services";
import { Link } from "react-router-dom";
import { routes } from "../../constants/routes";
import Avatar from "../../components/Image/AvatarPreview";
import { globalConstant } from "../../constants/globalConstant";
import { EventService } from "../../services";
import RolePermission from "../../services/RolePermission";
import { UserRoleType } from "../../constants/Enum";

const AccountHeader = (props) => {
  const loginUser = AuthService.getLoginUser();

  const title = props?.title;

  return (
    <React.Fragment>
      <section className="account-login">
        <div className="container">
          <div className="row">
            <div className="col-sm-12 col-md-6 col-lg-6">
              <div className="account-profile">
                <h4>{title}</h4>
                <div className="account-profile1">
                  <div className="account-profile-text">
                    <h5>
                      <Avatar
                        imageUrl={loginUser?.profileUrl}
                        altText={loginUser?.firstName?.toUpperCase()[0]}
                        size={40}
                        borderColor={globalConstant.COLOR_LITE}
                        backgroundColor={globalConstant.COLOR_PINK}
                        borderWidth={globalConstant.BOARDER_THIN}
                      />
                      {loginUser?.firstName} {loginUser?.lastName}
                    </h5>
                  </div>
                  <div className="account-profile-button">
                    <Link to={routes.ACCOUNT_PERSONALINFO}>Go to profile</Link>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-sm-12 col-md-6 col-lg-6">
              <div className="account-profile second">
                <h5>
                  <span style={{ height: "40px" }}></span>
                  {/* <Avatar
                    imageUrl="/assets/images/global.png"
                    altText={loginUser?.firstName?.toUpperCase()[0]}
                    size={35}
                    borderColor={globalConstant.COLOR_LITE}
                    backgroundColor={globalConstant.COLOR_PINK}
                    borderWidth={globalConstant.BOARDER_THIN}
                  />
                  Global traders */}
                </h5>
                <div className="account-profile1">
                  {!(loginUser?.role === UserRoleType.CUSTOMER) && (
                    <div className="account-profile-button one">
                      <Link to={routes.ACCOUNT_BUSINESSINFO}>
                        Business page
                      </Link>
                    </div>
                  )}
                  <div className="account-profile-button">
                    <Link to={routes.ACCOUNT_DASHBOARD}>Dashboard</Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};
export default AccountHeader;
